<script>
import moment from 'moment';
import countries from 'viralstyle-ui/src/shippableCountries';
import BuyerSelect from 'sales-flow-ui/components/BuyerSelect';
import { mapState } from 'vuex';

import securityImg from '@/assets/images/security-seals.png';

export default {
  components: {
    BuyerSelect,
  },
  data: () => ({
    securityImg,
    countries,
  }),
  computed: {
    ...mapState({
      customer: state => state.checkout.customer,
      currencyInfo: state => state.currencyInfo,
      itemCount: state => state.cart.cart.items.length,
    }),
    year() {
      return moment().year();
    },
  },
  methods: {
    inputSelectCountry(e) {
      let value = e.target.value;

      this.updateState(this.$store.state.checkout.customer, 'country', value);

      if (this.itemCount) {
        this.$store.dispatch('patchCartGeo');
      }

      this.$store.dispatch('getCurrencyInfo', value);
    },
  },
};
</script>

<template lang='pug'>
.w-full.md_w-1-3.lg_w-1-2.font-archivo
  buyer-select.md_max-w-xs.mx-1.mt-3_5.md_m-0(
    hide-label,
    label='Country',
    type='footer',
    :value='customer.country',
    @input='inputSelectCountry',
  )
    option(
      v-for='(country, code) in countries',
      :value='code',
    ) {{code === customer.country ? `(${currencyInfo.currency_symbol}) ${country}` : country}}

  img.opacity-100.mt-2.md_max-w-xs.w-full.px-2_5.md_p-0(v-lazy='securityImg', alt='security seals')

  .text-brand-secondary-800.mt-5.text-center.md_text-sm Copyright © {{year}} ViralStyle. All rights reserved.
  .flex.mt-_5.items-center.leading-none.justify-center
    router-link.text-brand-secondary-400.text-center.md_text-sm.hover_underline(:to='{ name: "privacy" }') Privacy Policy
    .text-brand-secondary-800 &nbsp;|&nbsp;
    router-link.text-brand-secondary-400.text-center.md_text-sm.hover_underline(:to='{ name: "terms" }') Terms of Service
</template>

<style>
@import '~import/index';
</style>